const transformDateString = (str) => {
  if (!str || typeof str !== "string")
    return "";
  const match = str.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!match)
    return str;
  const [, day, month, year] = match;
  return `${year}-${month}-${day}`;
};
export default transformDateString;
